import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Space, Typography } from 'antd';

import ShelfComponent from '@/components/shared/Shelf';
import { shelvesApi } from '@/services/shelves';
import styled, { StyledProp } from '@/styled';

import Card from '../../Card';

interface IShelfProps {
  title: string;
  id: number;
  index: number;
}

const Shelf = ({ className, id, title, index }: StyledProp & IShelfProps) => {
  const navigate = useNavigate();
  const [refetch, { data: shelf, isFetching, isUninitialized }] = shelvesApi.endpoints.getShelf.useLazyQuery({});

  useEffect(() => {
    refetch({ id, page: 1, size: 12 });
  }, [id, refetch]);

  const handleClickSeeAll = () => {
    navigate(`/trilha/${id}`);
  };

  if (!isUninitialized && shelf?.total_rows === 0) return null;

  return (
    <div className={className}>
      <ShelfComponent
        shelfProps={{
          isFetching,
          index
        }}
        carouselProps={{ slidesToShow: 4, spaceBetween: 16 }}
        title={
          <Space size={32}>
            <Typography.Title level={4} ellipsis>
              {title}
            </Typography.Title>
            {shelf?.total_pages > 1 && (
              <Typography.Text className='shelfcarrousel-clickable-text' underline onClick={handleClickSeeAll}>
                Ver Todos
              </Typography.Text>
            )}
          </Space>
        }
      >
        {shelf?.data.map(course => (
          <swiper-slide key={course.id}>
            <Card {...course} />
          </swiper-slide>
        ))}
      </ShelfComponent>
    </div>
  );
};

export default styled(Shelf)`
  swiper-container {
    overflow: visible;
  }

  & .carouselNavigator-container {
    height: 100%;
    margin: 1px;
    border-radius: 4px;
  }

  .swiper-shelves {
    margin-top: 20px;
  }

  .shelfcarrousel-clickable-text {
    cursor: pointer;
  }

  .moreInfo {
    width: 100%;
    z-index: 2;
  }

  overflow: hidden;
  padding-bottom: 106px;
  margin-bottom: -88px;
`;
